import React, { useState } from "react";
import "../GSPagesStyles/GSHeading.css";
import gsLogo from "../../../Images/GSHome/Sparkle.png";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

export default function GSHeading() {
  const navigate = useNavigate();
  const [isMenuActive, setIsMenuActive] = useState(false);

    const toggleMenu = () => {
        setIsMenuActive(!isMenuActive);
    };
  return (
    <div className="gsHeadingMainOuterBox">
      <div onClick={() => navigate("/gshome")} className="gsHeadingLogoBox">
        <img width={174} height={45} src={gsLogo} alt="LoyalString" />
      </div>
      <div className="gsHeadingNavBoxMain">
        <nav>
        <ul id="nav-links" className={isMenuActive ? 'active' : ''}>
          <li onClick={() => navigate("/gshome")}>Home</li>
          <li>About</li>
          <li>Products</li>
          <li>Services</li>
          <li onClick={() => navigate("/adminpanellogin")}>Login</li>
        </ul>
          {/* <li>Services</li> */}
        </nav>
        {/* <!-- ADD BUTTON TAG ONLY --> */}
            {/* <button class="menu-toggle" onClick={toggleMenu}>☰</button> */}
            <Icon className="menu-toggle" style={{color: '#0077d4', fontWeight: 'bold'}}  onClick={toggleMenu} icon="line-md:menu" width="24" height="24" />
        </div>
    </div>
  );
}

// import React from "react";
// import "../GSPagesStyles/GSHeading.css";
// import gsLogo from "../../../Images/GSHome/loyalStringLogoWide.png";
// import { useNavigate } from "react-router-dom";

// export default function GSHeading() {
//   const navigate = useNavigate();
//   return (
//     <div className="gsHeadingMainOuterBox">
//       <div onClick={() => navigate("/gshome")} className="gsHeadingLogoBox">
//         <img src={gsLogo} alt="LoyalString" />
//       </div>
//       <div className="gsHeadingNavBoxMain">
//         <nav>
//           <li onClick={() => navigate("/gshome")}>Home</li>
//           <li>About</li>
//           <li>Products</li>
//           <li>Services</li>
//           <li onClick={() => navigate("/adminpanellogin")}>Login</li>
//           {/* <li>Services</li> */}
//         </nav>
//       </div>
//     </div>
//   );
// }
